import React, { useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { createBilldaThemeWithMode } from '@billda/shared-ui';
import { useThemeStore } from '../../stores/themeStore';
import { useDensityStore } from '../../stores/densityStore';
import { useTablePreferencesStore } from '../../stores/tablePreferencesStore';

interface ConstructionThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Theme provider for the application
 */
export const ConstructionThemeProvider: React.FC<
  ConstructionThemeProviderProps
> = ({ children }) => {
  const { mode, initializeTheme } = useThemeStore();
  const { density, initializeDensity } = useDensityStore();
  const { initializePreferences } = useTablePreferencesStore();

  useEffect(() => {
    initializeTheme();
    initializeDensity();
    initializePreferences();
  }, [initializeTheme, initializeDensity, initializePreferences]);

  const theme = createBilldaThemeWithMode(mode, undefined, density);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </MuiThemeProvider>
  );
};
